import { PlanModelInfo, planTypes } from '@/common/constants';
import { defaultMapper } from '@/common/service/default-mapper';
import { planUnitMap } from '@/common/product-unit';

export const ZoomRoomCategories = {
  ZR: 'zr',
};

export default (planMapJSON) => {
  return defaultMapper({
    ...planMapJSON[ZoomRoomCategories.ZR],
    typeNameKey: 'billing.planform.title.zoomroom',
    planNameKey: 'billing.planform.title.zoomroom',
  }, planTypes.ZOOM_ROOMS).map((p) => {
    return {
      ...p,
      min: 1,
      max: 49,
      unit: planUnitMap.room,
      planModel: PlanModelInfo.license
    };
  });
}
